import { CommonModule } from '@angular/common';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { SpinnerService, SpinnerState } from './spinner.service';
import { Subscription } from 'rxjs';

@Component({
	selector: 'app-fullscreen-spinner',
	standalone: true,
	imports: [CommonModule],
	templateUrl: './fullscreen-spinner.component.html',
	styleUrls: ['./fullscreen-spinner.component.scss']
})
export class FullscreenSpinnerComponent {
	@Input() visible = false;
	@Input() message = 'Please wait...';
}